(function() {

    'use strict';

    var ItxProductSwiperCmp = {
        bindings: {
            arrayImages: '<',
            product:'<'
        },
        controller: ItxProductSwiperCmpCtrl,
        controllerAs: '$ctrl',
        templateUrl: 'productSwiperCmp.html'
    };

    ItxProductSwiperCmpCtrl.$inject = ['$timeout','$rootScope'];

    function ItxProductSwiperCmpCtrl($timeout,$rootScope) {
        var _this = this;

        _this.$onInit = function() {           
            _this.initSwiper();
        };  
        _this.swiperObj =null;

        _this.$onDestroy = function(){
           
            // _this.swiperObj.destroy( true, true );
        };
    
        _this.$onChanges = function() {
            /*if(_this.swiperObj){
                _this.swiperObj.destroy( true, true );
            }
             _this.initSwiper();
            */
        };

        _this.zoom = function(index,$event) {
            $rootScope.$broadcast('itx-product-zoom:initialize', {
                images: _this.arrayImages,
                index: index,
                event: $event,
                productId: _this.product.id
            });
        };



        _this.showVideo = function(image){
            image.showVideo = true;
        };


//   var breakpoint = window.matchMedia( '(min-width:600px)' );

//      var mySwiper;

  

//      _this.breakpointChecker = function() {

//       if ( breakpoint.matches === true ) {
  

//         if ( mySwiper !== undefined )
            
//             { 
                
//                 mySwiper.destroy( true, true );
//                 document.body.style.backgroundColor = "red";
//                 return;
//             }
  
//         // else if a small viewport and single column layout needed
//         } else if ( breakpoint.matches === false ) {

//           document.body.style.backgroundColor = "blue";
//           return  _this.initSwiper();
  
//         }
  
//     };
  

//     breakpoint.addListener(_this.breakpointChecker());
//     _this.breakpointChecker();
  
  


        _this.initSwiper = function() {
            $timeout(function() {
                _this.swiperObj = new Swiper('.swiper-container', { //jshint ignore:line
                    speed: 250,
                    slidesPerView: 1,
                    observer: true,
                    navigation: {
                        nextEl: '.ma-swiper-button-next',
                        prevEl: '.ma-swiper-button-prev',
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        type: 'bullets',
                        clickable: true
                    }
                });
            }, 1);  
        };
         
    }

    angular.module('itxApp.common')
        .component('itxProductSwiper', ItxProductSwiperCmp);

})();